import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from './supabase';
import { buildAuthRedirectPath } from './utils/authRedirect';

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setStatus('sending');
        setMessage('');

        const { error } = await supabase.auth.resetPasswordForEmail(email, {
            redirectTo: buildAuthRedirectPath('/reset-password'),
        });

        if (error) {
            setStatus('error');
            setMessage(error.message || 'Failed to send reset email. Check the address or try again.');
        } else {
            setStatus('sent');
            setMessage('Password reset email sent! Check your inbox.');
        }
    };

    return (
        <div className="auth-page-shell">
            <div className="page-panel auth-card">
                <div className="auth-header">
                    <div className="auth-icon-badge" style={{ background: 'linear-gradient(135deg, #2563eb, #4f46e5)' }}>?</div>
                    <p className="hero-eyebrow">Account Recovery</p>
                    <h1 className="page-title">Forgot Password?</h1>
                    <p className="auth-subcopy">Enter your email address and we will send you a secure link to reset your password.</p>
                </div>

                {status === 'sent' ? (
                    <div style={{ textAlign: 'center' }}>
                        <div className="auth-feedback success" style={{ marginBottom: '2rem' }}>
                            {message}
                        </div>
                        <Link to="/login" className="btn primary" style={{ width: '100%' }}>Back to Login</Link>
                    </div>
                ) : (
                    <form className="auth-form" onSubmit={handleSubmit}>
                        {status === 'error' && (
                            <div className="auth-feedback error">{message}</div>
                        )}
                        <input type="email" id="forgot-password-email" name="email" className="input-field" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        <div className="form-actions">
                            <button type="submit" className="btn primary" disabled={status === 'sending'}>{status === 'sending' ? 'Sending...' : 'Send Reset Link'}</button>
                            <Link to="/login" className="btn tertiary" style={{ marginTop: '0.5rem' }}>Cancel</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
